<div class="header">
  <img
    class="logo"
    [alt]="'Firmenlogo ' + organisationName"
    [src]="assetBucketUrl + imageData.imgSrc"
    [attr.width]="imageData.imgWidth"
    [attr.height]="imageData.imgHeight"
  />
</div>
